import { render, staticRenderFns } from "./information-update.vue?vue&type=template&id=ccd5b298&scoped=true&"
import script from "./information-update.vue?vue&type=script&lang=js&"
export * from "./information-update.vue?vue&type=script&lang=js&"
import style0 from "./information-update.vue?vue&type=style&index=0&id=ccd5b298&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd5b298",
  null
  
)

export default component.exports